/* eslint-disable no-case-declarations */
/* eslint no-case-declarations: 1  */ // --> WARN
import {
  BaseValidationDefinition,
  FieldDefinition,
  ListFieldDefinition,
  NumericFieldDefinition,
  StringFieldDefinition,
  tryConvert,
  ValidationDefinition,
} from '@msdk/definitions'

export function processCondition(condition: string) {
  const andPattern = /(^|\W)AND($|\W)/g
  const orPattern = /(^|\W)OR($|\W)/g
  return condition.replace(andPattern, ' && ').replace(orPattern, ' || ')
}

export function processField(f: FieldDefinition, onList?: string): BaseValidationDefinition[] {
  let res: BaseValidationDefinition[] = []
  switch (f.fieldDefinitionType) {
    case 'Numeric':
      const numericDef = f as NumericFieldDefinition
      const { step } = numericDef
      if (step > 0) {
        const validation: ValidationDefinition = {
          condition: `!entity.IsEmpty('${f.name}') AND !entity.MatchToStep('${f.name}',${step})`,
          field: f.name,
          msgCode: 'FRM_00025',
          validationType: 'Expression',
          onList,
          msgParameters: tryConvert(step, numericDef.um, numericDef.entityName, numericDef.name).toString(),
        }
        res.push(validation)
      }
      break
    case 'String':
      const stringDef = f as StringFieldDefinition
      const maxLength = stringDef.maxLength <= 0 ? 4000 : stringDef.maxLength
      const validation: ValidationDefinition = {
        condition: `!entity.IsEmpty('${f.name}') AND entity.Str('${f.name}').length > ${maxLength}`,
        field: f.name,
        msgCode: 'FRM_00004',
        validationType: 'Expression',
        onList,
        msgParameters: `${maxLength}`,
      }
      res.push(validation)
      break
    case 'List':
      const listDef = f as ListFieldDefinition
      let listVal: BaseValidationDefinition[] = []
      listDef.fields.forEach((lf) => {
        const val = processField(lf, listDef.name)
        listVal = listVal.concat(val)
      })
      res = res.concat(listVal)
      break
    case 'DateTime':
    case 'DateTimeUnknown':
      const dateValidation: ValidationDefinition = {
        condition: `!entity.IsEmpty('${f.name}') AND !entity.IsValidDate('${f.name}')`,
        field: f.name,
        msgCode: 'FRM_00005',
        validationType: 'Expression',
        onList,
      }
      res.push(dateValidation)
      break
  }
  return res
}
